import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useT } from "@/i18n/i18n";
import api from "@/lib/api";
import { DemoBadge, StatusBadge } from "@/components/shared";
import { QrCode } from "lucide-react";

export default function Trace() {
  const { traceId } = useParams();
  const { lang } = useT();
  const L = (pl, en) => (lang === "pl" ? pl : en);
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/public/trace/${traceId}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [traceId]);

  if (err) return <div className="mx-auto max-w-2xl px-4 py-20 text-center text-mutedtext">{L("Nie znaleziono rekordu identyfikowalności.", "Trace record not found.")}</div>;
  if (!data) return <div className="mx-auto max-w-2xl px-4 py-20 text-center text-mutedtext">…</div>;

  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <div className="flex items-center gap-3">
        <QrCode className="h-8 w-8 text-forest" aria-hidden="true" />
        <div>
          <div className="font-mono text-sm text-mutedtext">{data.trace_id}</div>
          <h1 className="font-heading text-2xl font-bold text-charcoal">{data.product}{data.variety ? ` — ${data.variety}` : ""}</h1>
        </div>
        {data.is_demo && <DemoBadge className="ml-auto" />}
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        <Info label={L("Region produkcji", "Production region")} value={<span className="capitalize">{data.producer_region}</span>} />
        <Info label={L("Organizacja producenta", "Producer organization")} value={data.producer_organization} />
        <Info label={L("Okres zbioru", "Harvest period")} value={data.harvest_period} />
        <Info label="Status" value={<StatusBadge status={data.status} />} />
      </div>

      <Section title={L("Przetwórstwo", "Processing")} rows={data.processing.map((p) => `${p.process_type} · ${p.quantity} · ${p.processor} (${p.status})`)} empty={L("Brak", "None")} />
      <Section title={L("Miejsca przeznaczenia", "Destinations")} rows={data.destinations.map((d) => `${d.buyer} · ${d.quantity} (${d.channel})`)} empty={L("Brak", "None")} />
      <Section title={L("Odzysk", "Recovery")} rows={data.recovery.map((r) => `${r.destination} · ${r.quantity} (${r.impact_status})`)} empty={L("Brak", "None")} />

      <p className="mt-8 text-xs text-mutedtext">{L("Strona zawiera wyłącznie bezpieczne informacje publiczne. Nie ujawniamy adresu, telefonu, danych bankowych ani poufnych cen kontraktowych.", "This page shows safe public information only. We do not expose address, phone, bank details or confidential contract prices.")}</p>
    </div>
  );
}

function Info({ label, value }) {
  return <div className="rounded-md border border-subtle bg-white p-4"><div className="text-xs uppercase tracking-wide text-mutedtext">{label}</div><div className="mt-1 text-sm font-medium text-charcoal">{value}</div></div>;
}
function Section({ title, rows, empty }) {
  return (
    <div className="mt-6">
      <h2 className="font-heading text-lg font-bold text-charcoal">{title}</h2>
      <ul className="mt-2 space-y-1 text-sm text-charcoal">
        {rows.length ? rows.map((r, i) => <li key={i} className="rounded border border-subtle bg-white px-3 py-2">{r}</li>) : <li className="text-mutedtext">{empty}</li>}
      </ul>
    </div>
  );
}
